import { useEffect } from 'react';

import { useUser } from 'global/UserContext';
import usePlanType from 'hooks/usePlanType';
import { apiAdvisor } from 'services/apiService';

const usePingOnline = () => {
  const { user } = useUser();
  const planType = usePlanType();

  useEffect(() => {
    if (!planType.isAdvisor) {
      console.log('User is not an Advisor, ping not started.');
      return;
    }

    let intervalId: NodeJS.Timeout | null = null;

    const sendPing = async (idAdvisor: string) => {
      try {
        await apiAdvisor.patch(`/v1/advisors/${idAdvisor}/ping-online`);
        console.log('Ping sent successfully to Advisor:', idAdvisor);
      } catch (error) {
        console.error('Failed to send ping:', error);
      }
    };

    const fetchAdvisorIdAndStartPing = async () => {
      if (user?.id) {
        try {
          const response = await apiAdvisor.get(`/v1/advisors/by-user-id/${user.id}`);
          const idAdvisor = response.data.id;

          if (idAdvisor) {
            console.log('Advisor ID found:', idAdvisor);
            sendPing(idAdvisor);
            intervalId = setInterval(() => {
              sendPing(idAdvisor);
            }, 150000);
          } else {
            console.log('Advisor ID not found for user:', user.id);
          }
        } catch (error) {
          console.error('Failed to fetch advisor ID:', error);
        }
      }
    };

    fetchAdvisorIdAndStartPing();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log('Ping interval cleared');
      }
    };
  }, [user]);
};

export default usePingOnline;
